import { render, staticRenderFns } from "./ListReceipt.vue?vue&type=template&id=24c31b46&scoped=true"
import script from "./ListReceipt.vue?vue&type=script&lang=ts"
export * from "./ListReceipt.vue?vue&type=script&lang=ts"
import style0 from "./ListReceipt.vue?vue&type=style&index=0&id=24c31b46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c31b46",
  null
  
)

export default component.exports